import i18n from "~/plugins/i18n";

/**
 * Opciones de los enums del contrato del log del balanceador.
 * Se declaran aqui para que el filtro y la celda pinten siempre lo mismo.
 */
export const LOG_EVENTS = [
    "balancing_received",
    "shipment_attempt",
    "shipment_result",
    "no_active_members",
    "not_delivered_any",
    "exception",
];

export const LOG_OUTCOMES = [
    "ok",
    "rejected",
    "error",
    "pending",
    "capped",
    "stopped",
    "already_sent",
    "not_sent",
    "async_queued",
];

export const LOG_ENQUEUE_SOURCES = [
    "capture_api",
    "delivery_group_plugin",
    "throttling_requeue",
    "review_send_next",
];

/** Color del badge por outcome. Lo que no esta aqui se pinta neutro. */
export const LOG_OUTCOME_COLORS = {
    ok: "success",
    rejected: "warning",
    error: "danger",
    pending: "info",
};

const enumOptions = (values) =>
    values.map((value) => ({
        value,
        label: i18n.t(value),
    }));

const selectFilter = (values) => ({
    active: false,
    value: null,
    condition: "is_equal_to",
    type: "select",
    options: enumOptions(values),
});

export default {
    fields: [
        {
            key: "created_at",
            label: "created_at",
            sorter: false,
            filter: false,
            _filter: false,
            active: true,
            _active: true,
            fixed: true,
            _style: "width:12%",
        },
        {
            key: "lead_id",
            label: "lead_id",
            sorter: false,
            // Filtro de columna: el endpoint solo acepta `equal` en este campo
            // y el adapter convierte el `like` de la columna en `equal`.
            filter: true,
            _filter: false,
            active: true,
            _active: true,
            _style: "width:8%",
        },
        {
            key: "event",
            label: "event",
            sorter: false,
            filter: false,
            _filter: selectFilter(LOG_EVENTS),
            active: true,
            _active: true,
            _style: "width:10%",
        },
        {
            key: "outcome",
            label: "outcome",
            sorter: false,
            filter: false,
            _filter: selectFilter(LOG_OUTCOMES),
            active: true,
            _active: true,
            _style: "width:8%",
        },
        {
            // Se filtra por id (lo unico que acepta el endpoint) y se pinta el
            // nombre denormalizado que viene en la propia fila.
            key: "client_id",
            label: "output",
            sorter: false,
            filter: false,
            _filter: selectFilter([]),
            active: true,
            _active: true,
            _style: "width:12%",
        },
        {
            key: "input_campaign_id",
            label: "input",
            sorter: false,
            filter: false,
            _filter: selectFilter([]),
            active: true,
            _active: true,
            _style: "width:12%",
        },
        {
            key: "enqueue_source",
            label: "enqueue_source",
            sorter: false,
            filter: false,
            _filter: selectFilter(LOG_ENQUEUE_SOURCES),
            active: true,
            _active: true,
            _style: "width:10%",
        },
        {
            key: "delivery_method",
            label: "delivery_method",
            sorter: false,
            filter: false,
            _filter: false,
            active: true,
            _active: true,
            _style: "width:7%",
        },
        {
            key: "http_status",
            label: "http_status",
            sorter: false,
            filter: false,
            _filter: false,
            active: true,
            _active: true,
            _style: "width:6%",
        },
        {
            key: "message",
            label: "message",
            sorter: false,
            filter: true,
            _filter: false,
            active: true,
            _active: true,
            _style: "width:15%",
        },
    ],
    allFields: [],
    items: [],
    rows: 20,
    page: 1,
    total_pages: 0,
    loading: true,
    hover: true,
    responsive: true,
    pagination: true,
    // El endpoint no documenta ordenacion, asi que no se ofrece.
    sorter: false,
    size: "sm",
    columnFilter: {
        external: true,
        lazy: true,
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null,
};
